export default __webpack_public_path__ + "locales/en/People.json?hash=77e232bbdcaab6a5469280558cff7eca";